import {
  Accordion,
  AccordionArrow,
  AccordionButton,
  AccordionHeading,
  AccordionItem,
  AccordionPanel,
  Text,
} from '@hausgold/designsystem';
import get from 'lodash/get';
import React from 'react';
import {
  analyticsTrack,
  EVENT_OBJECT,
  EVENT_VERB,
  eventBuilder,
} from '../utils/tracking';

/**
 *
 * Accordion that is displayed as a FAQ List.
 *
 * @param entry  {Objext}
 * @returns {JSX.Element}
 */
const ContentfulFaqList = ({ entry }) => {
  if (!entry.faqItems) {
    return null;
  }

  const handleClick = (label) => {
    analyticsTrack({
      event: eventBuilder(EVENT_OBJECT.button, EVENT_VERB.interacted),
      params: {
        label,
        element_type: 'ContentfulFAQList',
      },
    });
  };

  return (
    <div>
      {entry.faqItems.map((item) => (
        <Accordion colorScheme="blue" mb={2} key={item.id}>
          <AccordionItem bg="whiteAlpha.100">
            <AccordionButton
              bg="whiteAlpha.100"
              border="0 none"
              outline="none"
              p="6"
              onClick={() => {
                handleClick(item.question);
              }}
            >
              <AccordionHeading hyphens="auto" p="0" mb="0" mr="6">
                {item.question}
              </AccordionHeading>
              <AccordionArrow />
            </AccordionButton>

            <AccordionPanel>
              <Text
                fontSize="lg"
                color="gray.400"
                className="markdown"
                dangerouslySetInnerHTML={{
                  __html: get(item, 'answer.childMarkdownRemark.html'),
                }}
              />
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      ))}
    </div>
  );
};

export default ContentfulFaqList;
